module.exports = __webpack_public_path__ + "static/periodic-table-4525030e0b51caa70221cd3db345d3f1.png";